import React, { useState } from "react";
import "./CharterRequests.css";
import { FaFilter, FaSearch, FaEllipsisV } from "react-icons/fa";

// Mock data for charter requests
const chartRequestData = [
  {
    id: 1,
    vesselName: "ASD Tug Navigator",
    companyName: "Anchorjeti",
    vesselType: "AHTS 001",
    receivedTime: "3 hours ago",
    status: "Pending",
    image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
  },
  {
    id: 2,
    vesselName: "ASD Tug Navigator",
    companyName: "Anchorjeti",
    vesselType: "AHTS 001",
    receivedTime: "5 hours ago",
    status: "Approved",
    image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
  },
  {
    id: 3,
    vesselName: "ASD Tug Navigator",
    companyName: "Anchorjeti",
    vesselType: "AHTS 001",
    receivedTime: "5 hours ago",
    status: "In Use",
    image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
  },
  {
    id: 4,
    vesselName: "ASD Tug Navigator",
    companyName: "Anchorjeti",
    vesselType: "AHTS 001",
    receivedTime: "5 hours ago",
    status: "Declined",
    image: "https://res.cloudinary.com/du44pwjoi/image/upload/v1742471097/csv_klkqpb.png"
  }
];

export default function CharterRequests() {
  const [activeTab, setActiveTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  
  // Status class mapping
  const getStatusClass = (status) => {
    switch(status) {
      case "Pending": return "pending";
      case "Approved": return "approved";
      case "In Use": return "in-use";
      case "Declined": return "declined";
      default: return "";
    }
  };
  
  // Filter charter requests based on active tab and search query
  const filteredRequests = chartRequestData.filter(request => {
    // Filter by tab
    if (activeTab === "Accepted" && request.status !== "Approved") {
      return false;
    }
    if (activeTab === "Declined" && request.status !== "Declined") {
      return false;
    }
    // We show all statuses when "All" is selected
    
    // Filter by search query
    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      return (
        request.vesselName.toLowerCase().includes(query) ||
        request.companyName.toLowerCase().includes(query) ||
        request.vesselType.toLowerCase().includes(query)
      );
    }
    
    return true;
  });

  return (
    <div className="charter-request-container">
      {/* Tabs */}
      <div className="charter-request-tabs">
        <div 
          className={`charter-request-tab ${activeTab === "All" ? "active" : ""}`}
          onClick={() => setActiveTab("All")}
        >
          All
        </div>
        <div 
          className={`charter-request-tab ${activeTab === "Accepted" ? "active" : ""}`}
          onClick={() => setActiveTab("Accepted")}
        >
          Accepted
        </div>
        <div 
          className={`charter-request-tab ${activeTab === "Declined" ? "active" : ""}`}
          onClick={() => setActiveTab("Declined")}
        >
          Declined
        </div>
      </div>
      
      {/* Actions */}
      <div className="charter-request-actions">
        <div className="charter-request-sort">
          <FaFilter />
          <span>Sort</span>
        </div>
        
        <div className="charter-request-search">
          <input 
            type="text" 
            placeholder="Search request" 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <FaSearch />
        </div>
      </div>
      
      {/* Table */}
      <table className="charter-request-table">
        <thead>
          <tr>
            <th className="charter-request-table-header">Vessel Name</th>
            <th className="charter-request-table-header">Company Name</th>
            <th className="charter-request-table-header">Vessel Type</th>
            <th className="charter-request-table-header">Reveived</th>
            <th className="charter-request-table-header">Status</th>
            <th className="charter-request-table-header"></th>
          </tr>
        </thead>
        <tbody>
          {filteredRequests.length > 0 ? (
            filteredRequests.map(request => (
              <tr key={request.id} className="charter-request-table-row">
                <td className="charter-request-table-cell">
                  <div className="charter-request-vessel-info">
                    <img 
                      src={request.image} 
                      alt={request.vesselName}
                      className="charter-request-vessel-image"
                    />
                    <span>{request.vesselName}</span>
                  </div>
                </td>
                <td className="charter-request-table-cell">{request.companyName}</td>
                <td className="charter-request-table-cell">{request.vesselType}</td>
                <td className="charter-request-table-cell">{request.receivedTime}</td>
                <td className="charter-request-table-cell">
                  <span className={`charter-request-status ${getStatusClass(request.status)}`}>
                    {request.status}
                  </span>
                </td>
                <td className="charter-request-table-cell">
                  <FaEllipsisV className="charter-request-options" />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "2rem" }}>
                No charter requests found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
} 